var styles = {"label":"RadioItem-module_label__TkMKI","alert":"RadioItem-module_alert__VeQl7"};

export { styles as default };
//# sourceMappingURL=RadioItem.module.scss.js.map
